
import { defineComponent, onBeforeUnmount, onMounted, ref } from 'vue'
import LanguageSwitcher from '@/components/sharable/LanguageSwitcher.vue'
import MainNavigation from '@/components/main-header/MainNavigation.vue'
import { useI18n } from 'vue-i18n'
import { useLocalStorage } from '@vueuse/core'

export default defineComponent({
  name: 'MainHeader',
  components: {
    LanguageSwitcher,
    MainNavigation,
  },
  props: ['onLogin', 'onReg'],
  setup() {
    const { locale, availableLocales } = useI18n({ useScope: 'global' })
    const screenWidth = ref(0)
    const locales = useLocalStorage('lang', 'RU')

    const updateWidth = () => {
      screenWidth.value = window.innerWidth
    }

    onMounted(() => {
      updateWidth()
      window.addEventListener('resize', updateWidth)
    })

    onBeforeUnmount(() => {
      window.removeEventListener('resize', updateWidth)
    })

    return {
      locales,
      screenWidth,
      localeState: locale,
      localeOptions: availableLocales,
    }
  },
  data() {
    return {
      lang: this.locales,
      menuVisible: false,
    }
  },
  computed: {
    activeColor(): string {
      const path = this.$route.path

      if (path.includes('/services/mt-clickbait')) return '#F6FF00'
      if (path.includes('/services/mt-agency')) return '#01AAFC'
      if (path.includes('/services/mt-shop')) return '#F50108'

      console.log(path)

      return '#FFFFFF' // fallback
    },
  },
  methods: {
    toggleMenu() {
      this.menuVisible = !this.menuVisible
    },
    changeLang(lang: string) {
      this.$i18n.locale = lang
      this.locales = lang
    },
  },
})
